import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContentPersonalizationStandardSetCreatorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ContentPersonalizationStandardSetCreatorsQuery = { __typename?: 'RootQueryType', standardSetCreators?: { __typename?: 'KeysetPageOfStandardSetCreator', results?: Array<{ __typename?: 'StandardSetCreator', id: string, name: string, type?: Types.StandardSetCreatorType | null }> | null } | null };


export const ContentPersonalizationStandardSetCreatorsDocument = gql`
    query ContentPersonalizationStandardSetCreators {
  standardSetCreators(first: 200) {
    results {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useContentPersonalizationStandardSetCreatorsQuery__
 *
 * To run a query within a React component, call `useContentPersonalizationStandardSetCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentPersonalizationStandardSetCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentPersonalizationStandardSetCreatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentPersonalizationStandardSetCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>(ContentPersonalizationStandardSetCreatorsDocument, options);
      }
export function useContentPersonalizationStandardSetCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>(ContentPersonalizationStandardSetCreatorsDocument, options);
        }
// @ts-ignore
export function useContentPersonalizationStandardSetCreatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>;
export function useContentPersonalizationStandardSetCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<ContentPersonalizationStandardSetCreatorsQuery | undefined, ContentPersonalizationStandardSetCreatorsQueryVariables>;
export function useContentPersonalizationStandardSetCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>(ContentPersonalizationStandardSetCreatorsDocument, options);
        }
export type ContentPersonalizationStandardSetCreatorsQueryHookResult = ReturnType<typeof useContentPersonalizationStandardSetCreatorsQuery>;
export type ContentPersonalizationStandardSetCreatorsLazyQueryHookResult = ReturnType<typeof useContentPersonalizationStandardSetCreatorsLazyQuery>;
export type ContentPersonalizationStandardSetCreatorsSuspenseQueryHookResult = ReturnType<typeof useContentPersonalizationStandardSetCreatorsSuspenseQuery>;
export type ContentPersonalizationStandardSetCreatorsQueryResult = Apollo.QueryResult<ContentPersonalizationStandardSetCreatorsQuery, ContentPersonalizationStandardSetCreatorsQueryVariables>;